import { OrganizationItemModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class OrganizationItemLoad {
  public static readonly type = '[OrganizationItem] Load';

  constructor(public payload: string) {}
}

export class OrganizationItemCreate {
  public static readonly type = '[OrganizationItem] Create';

  constructor(public payload: OrganizationItemModel) {}
}

export class OrganizationItemUpdate {
  public static readonly type = '[OrganizationItem] Update';

  constructor(public payload: OrganizationItemModel) {}
}

export class OrganizationItemDelete {
  public static readonly type = '[OrganizationItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; organizationId: string }) {}
}

export class OrganizationItemInitialState {
  public static readonly type = '[OrganizationItem] Set initial state';
}
